import { Component, CUSTOM_ELEMENTS_SCHEMA, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from './header/header.component';
import { MsalService } from '@azure/msal-angular';
import { DataService } from './services/data.service';
import { CommonModule } from '@angular/common';
import { ApiService } from './services/app.service';
import { Notification, NotificationComponent } from './notification/notification.component';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, HeaderComponent, CommonModule, NotificationComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  isAccessProvided = false;
  notification!: Notification;
  constructor(
    private msalService: MsalService,
    readonly apiService: ApiService,
    readonly dataservice: DataService
  ) {}

  ngOnInit() {
    this.handleMSALAccount();
    this.handleAccessRoles()
  }

  private handleAccessRoles(): void {
    this.fetchAccessRoles().then((shouldCarryOn: boolean) => {
      if(shouldCarryOn) {
        this.isAccessProvided = true;
      } else {
        this.notification = {
          label: 'Access Denied',
          description: 'You are not authorized to access IB Search Engine. You will be logged out shortly.',
          type: 'error'
        }
        setTimeout(() => {
          this.msalService.logoutRedirect();
        }, 500);
      }
    });
  }

  private fetchAccessRoles(): Promise<boolean> {
    return new Promise((resolve) => {
      this.apiService.getUserRoles().subscribe({
        next: (roles) => {
          this.dataservice.profile.accessRole = roles;
          if(roles.length > 0) {
            resolve(true);
          } else {
            resolve(false);
          }
        },
        error: (error) => {
          console.error('Error fetching user roles:', error);
          resolve(false);
        }
      });
    });
  }


  handleMSALAccount() {
    this.msalService.instance.handleRedirectPromise().then((result) => {
      if (result !== null && result.account !== null) {
        this.msalService.instance.setActiveAccount(result.account);
      } else {
        const currentAccounts = this.msalService.instance.getAllAccounts();
        if (currentAccounts.length > 0) {
          this.msalService.instance.setActiveAccount(currentAccounts[0]);
        }
      }
    });
  }
}
